
import { mapGetters } from 'vuex'
import ColorBall from '~/components/ColorBall'
import PaymentMethods from '~/modals/PaymentMethods'
import TruckIcon from '~/assets/svg/heroicons/truck.svg?inline=1'
import CurrencyIcon from '~/assets/svg/heroicons/currency.svg?inline=1'
import CheckIcon from '~/assets/svg/heroicons/check.svg?inline=1'
import LocationIcon from '~/assets/svg/heroicons/location.svg?inline=1'
import ClockIcon from '~/assets/svg/heroicons/clock.svg?inline=1'

export default {
  components: {
    ColorBall,
    TruckIcon,
    CurrencyIcon,
    CheckIcon,
    ClockIcon,
    LocationIcon
  },
  props: {
    productSlug: {
      type: String,
      required: true
    }
  },
  async fetch () {
    try {
      const { data } = await this.$axios.$get(
        `api/front/products/${this.productSlug}/variants/attributes`
      )

      this.options = data
    } catch (error) {
      console.error(error)
    }
  },
  data () {
    return {
      hide: false,
      loading: true,
      items: [],
      options: [],
      selected: {},
      selectedInventoryStatus: null,
      meta: null,
      inventoryStatuses: [
        {
          key: 'on_hand',
          text: this.$t('common.inventory_status_on_hand')
        },
        {
          key: 'in_transit',
          text: this.$t('common.inventory_status_in_transit')
        },
        {
          key: 'in_production',
          text: this.$t('common.inventory_status_in_production')
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      cartItems: 'cart/getItems',
      cartUUID: 'cart/getUUID'
    }),
    enablePrevPage () {
      return this.meta.current_page > 1
    },
    enableNextPage () {
      return this.meta.current_page < this.meta.last_page
    }
  },
  mounted () {
    if (process.browser) {
      this.loadInventories(1, true)
    }
  },
  methods: {
    openPaymentMethods () {
      this.$modal.show(PaymentMethods)
    },
    addItemToCart (uuid) {
      const successCallback = () => {
        this.loadInventories()
        this.$toast.clear()
        this.$toast.info(this.$t('common.item_has_been_add_to_bag'), {
          action: [
            {
              text: this.$t('common.checkout'),
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
                this.$router.push(this.$i18nPath(`/checkout/${this.cartUUID}`))
              }
            }
          ]
        })
      }

      this.$store
        .dispatch('cart/addCartItem', {
          uuid,
          cb: successCallback
        })
        .catch((error) => {
          if (error.response) {
            this.$toast.error(error.response.data.message)
          }
        })
    },
    goPrevPage () {
      if (this.enablePrevPage) {
        this.loadInventories(this.meta.current_page - 1)
      }
    },
    goNextPage () {
      if (this.enableNextPage) {
        this.loadInventories(this.meta.current_page + 1)
      }
    },

    toggleAttributeFilter (attributeId, valueId) {
      if (
        this.selected[attributeId] &&
        this.selected[attributeId] === valueId
      ) {
        delete this.selected[attributeId]
      } else {
        this.selected[attributeId] = valueId
      }

      this.loadInventories()
    },

    toggleInventoryStatus (status) {
      if (this.selectedInventoryStatus === status) {
        status = null
      }
      this.selectedInventoryStatus = status
      this.loadInventories()
    },

    async loadInventories (page = 1, firstLoad = false) {
      this.loading = true

      try {
        const { data, meta } = await this.$axios.$get(
          `api/front/products/${this.productSlug}/inventories`,
          {
            params: {
              page,
              values: this.selected,
              inventory_status: this.selectedInventoryStatus
            }
          }
        )

        this.meta = meta
        this.items = data

        if (firstLoad === true && this.items.length === 0) {
          this.hide = true
        }

        setTimeout(() => {
          this.loading = false
        }, 700)
      } catch (error) {
        console.error(error)
        setTimeout(() => {
          this.loading = false
        }, 700)
      }
    }
  }
}
